// const BASE_URL = 'http://localhost:5000/api';
const BASE_URL = 'https://budget-devjam.herokuapp.com/api';
//budget-devjam.herokuapp.com/
export default BASE_URL;